import React from 'react';
import { Star } from 'lucide-react';
const TESTIMONIALS = [{
  name: 'María',
  role: 'Mamá de 2 niños',
  quote: 'Dejamos de pelear todos los días. Ahora hay más calma en casa.',
  location: 'Buenos Aires'
}, {
  name: 'Lucas',
  role: 'Papá de 3',
  quote: 'Por primera vez siento que sé qué hacer con el celular.',
  location: 'Córdoba'
}, {
  name: 'Ana',
  role: 'Mamá',
  quote: 'No es teoría. Es práctico y real.',
  location: 'Rosario'
}, {
  name: 'Carolina',
  role: 'Mamá de mellizos',
  quote: 'Mis hijos volvieron a jugar juntos sin pantallas. No lo podía creer.',
  location: 'Mendoza'
}, {
  name: 'Martín',
  role: 'Papá primerizo',
  quote: 'Ojalá hubiera encontrado esto antes. Cambió nuestra rutina familiar.',
  location: 'La Plata'
}];
export function Testimonials() {
  return <section className="py-16 md:py-24 bg-white px-4" data-id="element-218">
      <div className="max-w-5xl mx-auto" data-id="element-219">
        <div className="text-center mb-12" data-id="element-220">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-221">
            Más de 200 familias ya cambiaron su dinámica
          </h2>
          <p className="text-gray-500" data-id="element-222">Historias reales de padres como vos</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-223">
          {TESTIMONIALS.map((t, i) => <div key={i} className="bg-white p-6 rounded-xl border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-224">
              <div className="flex gap-1 mb-4" data-id="element-225">
                {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 text-yellow-400 fill-yellow-400" data-id="element-226" />)}
              </div>
              <p className="text-gray-700 mb-6 leading-relaxed" data-id="element-227">"{t.quote}"</p>
              <div className="flex items-center gap-3" data-id="element-228">
                <div className="w-8 h-8 rounded-full bg-gray-100 flex items-center justify-center text-xs font-bold text-gray-500" data-id="element-229">
                  {t.name.charAt(0)}
                </div>
                <div data-id="element-230">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-231">{t.name}</p>
                  <p className="text-xs text-gray-500" data-id="element-232">
                    {t.role} · {t.location}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}